import { render, staticRenderFns } from "./PointStatusWidget.vue?vue&type=template&id=ec2ad068&"
import script from "./PointStatusWidget.vue?vue&type=script&lang=js&"
export * from "./PointStatusWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports